<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary no-add-btn">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ $tc("customers.customers", 2) }}</h1>
                    </v-col>
                </v-row>
            </div>

            <div class="wrap-datables no-add-btn">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="customers"
                            :items-per-page.sync="filters.per_page"
                            :options.sync="options"
                            :page.sync="filters.page"
                            :search="search"
                            :server-items-length="totalCustomers"
                            sort-by="name"
                            @update:items-per-page="perPageChanged"
                            @update:page="pageChanged"
                        >
                            <template #[`item.is_active`]="{ item }">
                                {{ $t(`global.${item.is_active}`) }}
                            </template>

                            <template #[`item.trays_picked_up`]="{ item }">
                                {{ $t(`global.${item.collect_trays}`) }}
                            </template>

                            <template #[`item.address_2`]="{ item }">
                                <div class="d-flex align-center">
                                    {{ item.address_2 | preventNull }}
                                </div>
                            </template>

                            <template #[`item.phone`]="{ item }">
                                <div class="d-flex align-center">
                                    {{ item.phone | preventNull }}
                                </div>
                            </template>

                            <template #[`item.actions`]="{ item }">
                                <v-btn
                                    class="see ma-1"
                                    icon
                                    small
                                    dark
                                    @click="
                                        $router.push({
                                            name: 'customers_detail',
                                            params: { id: item.id },
                                        })
                                    "
                                >
                                    <v-icon size="16">mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-col>
</template>

<script>
import debounce from "tiny-debounce";
import Config from "../../../config.singleton";

export default {
    name: "Customers",

    data() {
        return {
            customers: [],
            search: "",
            totalCustomers: 0,
            filters: {},
            default_filters: {
                search: null,
                per_page: null,
                page: null,
            },
            options: {},
            sorts: {
                sortName: 'asc'
            },
            headers: [
                {
                    text: Config.id_label ?? this.$t("customers.code"),
                    align: "start",
                    sortable: true,
                    value: "code",
                },
                {
                    text: this.$t("customers.name"),
                    align: "start",
                    sortable: true,
                    value: "name",
                },
                {
                    text: this.$tc("customers.address", 2, { number: 1 }),
                    align: "start",
                    sortable: true,
                    value: "address_1",
                },
                {
                    text: this.$tc("customers.address", 2, { number : 2 }),
                    align: "start",
                    sortable: true,
                    value: "address_2",
                },
                {
                    text: this.$tc("customers.zip_code", 2),
                    align: "start",
                    sortable: true,
                    value: "zipcode",
                },
                {
                    text: this.$tc("customers.city", 1),
                    align: "start",
                    sortable: true,
                    value: "city",
                },
                {
                    text: this.$t("customers.phone"),
                    align: "start",
                    sortable: true,
                    value: "phone",
                },
                {
                    text: this.$t("customers.active"),
                    align: "start",
                    sortable: true,
                    value: "is_active",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
            lastSort: null
        };
    },
    watch: {
        search: debounce(function (val) {
            this.getCustomers();
        }, 500),
        options(value) {
            const {sortBy, sortDesc} = value
            this.sorts = {}
            if (sortBy.length === 1 && sortDesc.length === 1) {
                let name = sortBy[0]
                    .split('_')
                    .map(el => el.charAt(0).toUpperCase() + el.slice(1))
                    .join('')
                this.sorts[`sort${name}`] = sortDesc[0] ? 'desc' : 'asc'
                this.lastSort !== name ? this.getCustomers() : null
                this.lastSort = name + sortDesc[0] ? 'desc' : 'asc'
            }
        }
    },
    async mounted() {
        this.filters = this.$root.getFilters('customers', this.default_filters)
        this.filters.expected_date = this.filters.expected_date ?? new Date().toISOString().substring(0, 10)
        this.filters.per_page = this.filters.per_page ?? 25

        this.$api.customers.all().then(({data: customers}) => {
                this.customers = customers.data
                this.totalCustomers = customers.meta.total
            }
        )

    },
    methods: {
        pageChanged() {
            let filters = this.$root.getFilters('customers',
                this.default_filters);
            filters.page = this.filters.page;
            this.$root.saveFilters("customers", filters)
            this.getCustomers();
        },
        perPageChanged() {
            let filters = this.$root.getFilters('customers',
                this.default_filters);
            filters.per_page = this.filters.per_page;
            this.$root.saveFilters("customers", filters)
            this.getCustomers();
        },
        getCustomers() {
            this.loading = true

            this.$api.customers.all({
                params: {
                    per_page: this.filters.per_page,
                    page: this.filters.page,
                    customer_search: this.search,
                    ...this.sorts
                }

            }).then(({data: customers}) => {
                this.customers = customers.data;
                this.totalCustomers = customers.meta.total;
            }).finally(() => this.loading = false)
        },

    },

};
</script>
